module.exports = __webpack_public_path__ + "static/media/big-data-forecast.8c08fc2b.png";